import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { HistoryService } from 'src/services/state/history/history.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-history-base',
  templateUrl: './history-base.component.html',
  styleUrls: ['./history-base.component.css']
})
export class HistoryBaseComponent extends BaseComponent implements OnInit {

  constructor(
    protected location: Location,
    protected historyService: HistoryService
  ) { 
    super()
  }

  ngOnInit(): void {
  }

  public back() {
    this.historyService.back();
  }

}
